import { API_URL } from 'core/constants'
import httpClient from './httpClient'
import { Contact } from 'core/types'
import useSWRImmutable from 'swr/immutable'

export const getUserInfo = async () =>
  (await httpClient.get<{ result: Contact }>(API_URL + '/api/dashboard/user/info')).data.result
export const useUserInfo = () => useSWRImmutable('/api/dashboard/user/info', getUserInfo)
